var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1815 6.37145L10.694 6.3802L12.0865 4.9877L12.154 4.3977C11.0495 3.4137 9.59128 2.81445 7.99778 2.81445C5.11278 2.81445 2.67778 4.77745 1.95703 7.43645C2.10903 7.33045 2.43403 7.40995 2.43403 7.40995L5.21653 6.95245C5.21653 6.95245 5.35953 6.7157 5.43203 6.72745C5.75739 6.37 6.15384 6.08446 6.59598 5.88914C7.03811 5.69381 7.51617 5.59302 7.99953 5.5932C8.82453 5.59495 9.58453 5.88645 10.1815 6.3687V6.37145Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0421 7.44269C13.7188 6.25019 13.0526 5.19719 12.1533 4.39844L10.1816 6.37019C10.9716 7.00769 11.4783 7.98319 11.4783 9.07519V9.42319C12.4376 9.42319 13.2168 10.2042 13.2168 11.1617C13.2168 12.1209 12.4358 12.9002 11.4783 12.9002H8.00132L7.65332 13.2502V15.3367L8.00132 15.6829H11.4783C12.6769 15.6813 13.8259 15.2044 14.6734 14.357C15.5209 13.5095 15.9979 12.3605 15.9996 11.1619C15.9978 9.62319 15.2246 8.26169 14.0421 7.44269Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52081 15.6846H7.99581V12.8996H4.52081C4.27392 12.8997 4.02991 12.8467 3.80531 12.7441L3.30356 12.8979L1.91106 14.2904L1.78906 14.7604C2.57378 15.359 3.53356 15.6831 4.52056 15.6826L4.52081 15.6846Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52125 6.64258C3.32269 6.64423 2.17369 7.12107 1.32616 7.96856C0.478624 8.81605 0.0017196 9.96502 0 11.1636C0 12.6318 0.70325 13.9373 1.7915 14.7643L3.8075 12.7483C3.50235 12.6107 3.24337 12.388 3.06161 12.1069C2.87985 11.8259 2.78303 11.4983 2.78275 11.1636C2.78275 10.2043 3.56375 9.42508 4.52125 9.42508C5.22625 9.42508 5.83225 9.85008 6.10625 10.4501L8.12225 8.43408C7.2955 7.34583 5.98975 6.64258 4.5215 6.64258H4.52125Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpLogo);
export default __webpack_public_path__ + "static/media/gcp_logo.868e218e68aa7df2c98bccc18cc4d1e2.svg";
export { ForwardRef as ReactComponent };